module.exports = __webpack_public_path__ + "static/media/Seta_aberta.c9263210.svg";